import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './NotificationsPage.scss';
import UIButton from '@/components/shared/UIButton';
import UIPageTitle from '@/components/shared/UIPageTitle';
import NotificationsList from '@/components/dashboard/Notifications';

const STORAGE_KEYS = {
  SELECTED_TYPE: 'dashboard_notifications_selected_type',
} as const;

const saveFiltersToStorage = (type: string) => {
  try {
    localStorage.setItem(STORAGE_KEYS.SELECTED_TYPE, type);
  } catch (error) {
    console.warn('Failed to save filters to localStorage:', error);
  }
};

const loadFiltersFromStorage = () => {
  try {
    return {
      type: localStorage.getItem(STORAGE_KEYS.SELECTED_TYPE) || 'all-types',
    };
  } catch (error) {
    console.warn('Failed to load filters from localStorage:', error);
    return {
      type: 'all-types',
    };
  }
};

const BackToDashboardButton = () => {
  const navigate = useNavigate();
  return (
    <UIButton
      outline={true}
      variant="primary"
      size="medium"
      onClick={() => navigate('/')}
    >
      Back to Home
    </UIButton>
  );
};

const NotificationsPage = () => {
  const savedFilters = loadFiltersFromStorage();
  const [selectedType, setSelectedType] = useState(savedFilters.type);

  useEffect(() => {
    saveFiltersToStorage(selectedType);
  }, [selectedType]);

  const handleTypeChange = (type: string) => {
    setSelectedType(type);
  };

  return (
    <>
      <UIPageTitle title="Notifications" action={<BackToDashboardButton />} />
      <div className="NotificationsPage__content">
        <NotificationsList
          selectedType={selectedType}
          onTypeChange={handleTypeChange}
        />
      </div>
    </>
  );
};

export default NotificationsPage;
